// extracted by mini-css-extract-plugin
export default {"layout":"Layout_layout__rvwG2","loader":"Layout_loader__h4n58"};